//- Handle cookies to show Sticky CTA after X minutes

const timmedStickyCTA = $('#timmedStickyCTA');

function timmedStickyCTAShow() {
    if (timmedStickyCTA.hasClass('hide')) {
        timmedStickyCTA.removeClass('hide');
    }
}

function timmedStickyCTAHide() {
    if (!timmedStickyCTA.hasClass('hide')) {
        timmedStickyCTA.addClass('hide');
    }
}

function checkCookies() {
    if ($(timmedStickyCTA).length) {
        if (typeof timePlayingCTA !== 'undefined' && typeof timePlayingCTA === 'number') {
            let durationExpires = new Date(new Date().getTime() + timePlayingCTA * 1000); //- seconds
            let resetTimeExpires = new Date(new Date().getTime() + 24 * 60 * 60 * 1000); //- hours

            timmedStickyCTAHide();

            if ($.cookie('OO-StickyCTA')) {
                timmedStickyCTAHide();
            }

            if (!$.cookie('OO-StickyCTA-Expires')) {
                $.cookie("OO-StickyCTA", 1, { expires: durationExpires });
                $.cookie("OO-StickyCTA-Expires", 1, { expires: resetTimeExpires });
            }

            if (!$.cookie('OO-StickyCTA') && $.cookie('OO-StickyCTA-Expires')) {
                timmedStickyCTAShow();
            }
        }
    }
}

checkCookies();

clearInterval(timeInterval);

let timeInterval = setInterval(checkCookies, 1000);
